<ng-template #adminLoginRequest let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Du är redan inloggad</h4>
  </div>
  <div class="modal-body">
    <p>Du är redan inloggad i en annan webbläsare eller på en annan dator.</p>
    <p>
      Vill du ta över inloggningen? Den andra inloggningen kommer då att
      avslutas och information kan förloras
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="acceptTakeover()">
      Ta över
    </button>
    <button type="button" class="btn btn-secondary" (click)="rejectTakeover()">
      Avbryt
    </button>
  </div>
</ng-template>
